import { createContext, useContext, useState, useEffect } from 'react';

// Safe defaults so destructuring never fails even outside provider
const DEFAULT = {
  cartOpen: false, checkoutOpen: false, searchOpen: false,
  enquiryOpen: false, mobileNavOpen: false, qvProduct: null, anyOpen: false,
  openCart: ()=>{}, closeCart: ()=>{}, openCheckout: ()=>{}, closeCheckout: ()=>{},
  openSearch: ()=>{}, closeSearch: ()=>{}, openEnquiry: ()=>{}, closeEnquiry: ()=>{},
  openMobileNav: ()=>{}, closeMobileNav: ()=>{}, openQV: ()=>{}, closeQV: ()=>{},
};

const UIContext = createContext(DEFAULT);

export function UIProvider({ children }) {
  const [cartOpen,      setCartOpen]      = useState(false);
  const [checkoutOpen,  setCheckoutOpen]  = useState(false);
  const [searchOpen,    setSearchOpen]    = useState(false);
  const [enquiryOpen,   setEnquiryOpen]   = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [qvProduct,     setQvProduct]     = useState(null);

  const anyOpen = cartOpen || checkoutOpen || searchOpen || enquiryOpen || mobileNavOpen || !!qvProduct;

  useEffect(() => {
    document.body.style.overflow = anyOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [anyOpen]);

  const openCart       = () => { setCartOpen(true); setCheckoutOpen(false); };
  const closeCart      = () => setCartOpen(false);
  const openCheckout   = () => { setCheckoutOpen(true); setCartOpen(false); };
  const closeCheckout  = () => setCheckoutOpen(false);
  const openSearch     = () => setSearchOpen(true);
  const closeSearch    = () => setSearchOpen(false);
  const openEnquiry    = () => setEnquiryOpen(true);
  const closeEnquiry   = () => setEnquiryOpen(false);
  const openMobileNav  = () => setMobileNavOpen(true);
  const closeMobileNav = () => setMobileNavOpen(false);
  const openQV         = (p) => setQvProduct(p);
  const closeQV        = () => setQvProduct(null);

  return (
    <UIContext.Provider value={{
      cartOpen, checkoutOpen, searchOpen, enquiryOpen, mobileNavOpen, qvProduct, anyOpen,
      openCart, closeCart, openCheckout, closeCheckout,
      openSearch, closeSearch, openEnquiry, closeEnquiry,
      openMobileNav, closeMobileNav, openQV, closeQV,
    }}>
      {children}
    </UIContext.Provider>
  );
}

export function useUI() { return useContext(UIContext); }